import EventEmitter from 'eventemitter3';

class BufferedEventEmitter extends EventEmitter {
  constructor() {
    super();
    this.buffer = new Map(); // Map of eventName -> array of emitted events
  }

  emit(eventName, ...args) {
    // If there are listeners, emit normally
    if (this.listenerCount(eventName) > 0) {
      return super.emit(eventName, ...args);
    }
    
    // Otherwise, buffer the event
    if (!this.buffer.has(eventName)) {
      this.buffer.set(eventName, []);
    }
    this.buffer.get(eventName).push(args);
    return false;
  }

  on(eventName, listener) {
    // Register the listener
    super.on(eventName, listener);
    
    // Replay any buffered events for this event name
    if (this.buffer.has(eventName)) {
      const bufferedEvents = this.buffer.get(eventName);
      bufferedEvents.forEach(args => {
        listener(...args);
      });
      // Clear the buffer for this event
      this.buffer.delete(eventName);
    }
    
    return this;
  }
}

export default BufferedEventEmitter;
